(function() {
    'use strict';

    angular
        .module('liverunApp')
        .controller('TrainerController', TrainerController);

    TrainerController.$inject = ['Trainer'];

    function TrainerController(Trainer) {

        var vm = this;

        vm.trainers = [];

        loadAll();

        function loadAll() {
            Trainer.query(function(result) {
                vm.trainers = result;
                vm.searchQuery = null;
            });
        }
    }
})();
